/**
 * Next number in a series: trailing digits + 1, prefix and digit width kept.
 * "12" → "13", "P09" → "P10", "P012" → "P013", "K9" → "K10". No trailing
 * digits → null. Shared by parking spots and storage units; mirrors
 * `nextNumberInSeries` on iOS.
 */
export const nextNumberInSeries = (previous: string): string | null => {
    const trimmed = (previous || '').trim();
    const match = /^(.*?)(\d+)$/.exec(trimmed);
    if (!match) return null;
    const prefix = match[1];
    const digits = match[2];
    const next = String(parseInt(digits, 10) + 1);
    const padded = next.length < digits.length ? next.padStart(digits.length, '0') : next;
    return prefix + padded;
};
